import { connect } from 'react-redux';
// import Report from '../../components/digital_rating/Report';
import IndicatorsDashbord from '../../components/dashboard/indicatorsDashbord/IndicatorsDashbord';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorsDashbord);
